var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.953,
    height: 36.811,
    viewBox: "0 0 79.953 36.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "offer-badge",
    transform: "translate(-1046 -117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15658",
    "data-name": "Path 15658",
    d: "M78.662,44.976c-1.981,6.908-10.9,9.327-23.243,2.484,6.5,8.771-.554,9.147-14.648,5.686C51.451,57.312,51.451,62.021,38.051,63c11.352.584,16.633,7.11,4.65,11.191,12.349-2.244,11.73-.868,7.248,5.246,7.99-4.01,14.1-4.719,14.159,1.349,4.513-4.1,17.031-7.19,28.583,1-1.673-5.263-.061-10.748,17.849-6.516-8.013-4.186-4.877-10.232,7.463-11.191-10.412-.378-18.447-5.218-4.776-12.033-8.886,2.5-21.114,2.993-14.055-4C88.159,53.774,80.317,51.573,78.662,44.976Z",
    transform: "translate(1007.949 72.024)",
    fill: "#fc2779"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferBadge);
export default __webpack_public_path__ + "static/media/offer-badge.017ed9e159ecffed89a4cab21d1da29e.svg";
export { ForwardRef as ReactComponent };